import { Employment } from '../../../member-profile/components/EmploymentStatus';

const EmploymentStatusPage = () => {
    return <Employment />;
};

export default EmploymentStatusPage;
